import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
  LEGACY_SCREEN_VIEW, NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import { formFields } from "./DeductiblePatientPayScheduleFormConfig";
import { useModal } from "../../common_nextgen/hooks/ModalContext";

import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const screenInfo = {
  ADD: ["Add Deductible Patient Pay Schedule Detail", "RCDEP002"],
  CHANGE: ["Deductible Patient Pay Schedule Detail", "RCDEP003"],
  VIEW: ["Deductible Patient Pay Schedule Detail", "RCDEP003I"],
};

const DeductiblePatientPayScheduleForm = ({ mode }) => {
  const location = useLocation();

  const { PATIENT_PAY_SCHEDULES, DEDUCTIBLE_SCHEDULE } = ROUTE_PATHS;

  /*const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedDepSeqNbrs = [],
    scheduleName = "",
    stepNumber = "",
    description,
    previousScreen = PATIENT_PAY_SCHEDULES,
    currentIndex: initialIndex = 0,
    initialParamsData = {
      dscScheduleName: scheduleName,
      dsdStepNumber: stepNumber,
      dscDescription: description,
    },
  } = currentState;*/

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedDepSeqNbrs = [],
    scheduleName = "",
    stepNumber = "",
    description,
    previousScreen = PATIENT_PAY_SCHEDULES,
    currentIndex: initialIndex = 0,
    initialParamsData = {
      dscScheduleName: scheduleName,
      dsdStepNumber: stepNumber,
      dscDescription: description,
    },
    lookupScreen,
    lookupParams,
    lookupMode: initialLookupMode = false,
    formData: baseFormData = {},
    navigateData,
  } = useMemo(() => {
    const {
      selectedDepSeqNbrs,
      previousScreen,
      currentIndex,
      scheduleName,
      description,
      stepNumber,
      initialParamsData,
      lookupScreen,
      lookupParams,
      lookupMode,
      formData,
      navigateData,
    } = currentState;
    return {
      selectedDepSeqNbrs,
      previousScreen,
      currentIndex,
      scheduleName,
      description,
      stepNumber,
      initialParamsData,
      lookupScreen,
      lookupParams,
      lookupMode,
      formData,
      navigateData,
    };
  }, [currentState]);

  console.log("sel sch", selectedDepSeqNbrs);

  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();
  const [parmsData, setParamsData] = useState(initialParamsData);
  // const handleBack = () => {
  //     if (currentIndex < selectedDepSeqNbrs.length - 1) {
  //         setCurrentIndex(currentIndex + 1);
  //         setCurrentMode(mode);
  //     } else {
  //         navigateToPage(DEDUCTIBLE_SCHEDULE, { selectedDepSeqNbrs: selectedDepSeqNbrs[currentIndex] });
  //     }
  // };
  /* Lookup data */
  /*const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData,formData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        acc[item["legacy"]] = formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };
  */
  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialFormData,
    initialLookupMode,
    initialIndex: currentIndex,
    lookupScreen,
    lookupParams,
    navigateData,
    previousState,
    currentState,
    currentMode,
  });
  const handleBack = () => {
    // console.log("initialFormData.dscDescription - ",initialFormData.dscDescription);
    console.log("initialFormData.dscDescription - ", description);
    if (currentIndex < selectedDepSeqNbrs.length - 1) {
      setLookupMode(false);
      setCurrentIndex(currentIndex + 1);
      //setInitialIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const handleMessage = (event) => {
    // Validate the origin dynamically 
    const url = new URL(event.origin);
    const hostnameWithoutPort = url.hostname;
    const trustedDomainPattern = /(^|\.)optum\.com$/;// checks for optum.com.
    if (!trustedDomainPattern.test(hostnameWithoutPort)) {
      console.warn("Blocked message from untrusted origin:", event.origin);
      return;
    }
    const { type, data } = event.data;

    if (type === "set-params") {
      setStateVal(data);
      //setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/depDedSchDtlPatPaySchd";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/depDedSchDtlPatPaySchd";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
       if (responseStatus.message === NO_CHANGE_OF_INFO) {
                    toast.current.show({
                      severity: "info",
                      summary: "",
                      detail: responseStatus.message,
                      life: 3000,
                    });
                  } else {
                    toast.current.show({
                      severity: "success",
                      summary: "",
                      detail: responseStatus.message,
                      life: 3000,
                    });
      setInitialFormData(responseData);
      setLookupMode(false);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      }
      
    } }catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const editValidation = () => {
    const params = {
      dscScheduleName: scheduleName,
      dsdStepNumber: stepNumber,
      depSeqNbr: selectedDepSeqNbrs[currentIndex].depSeqNbr,
    };
    axios_helper_no_header(
      "GET",
      "api/depDedSchDtlPatPaySchd/validateBeforeEdit",
      null,
      params
    )
      .then((response) => {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      })
      .catch((error) => {
        console.error("There was an error editing the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
        setLookupMode(false);
      };
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => editValidation();
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, setLookupMode, previousState, currentState]);

  const fetchInitialData = async () => {
    const params = isAddMode(currentMode)
      ? {
          dscScheduleName: scheduleName,
          dsdStepNumber: stepNumber,
          screenNumber: screenInfo.ADD[1],
        }
      : {
          depSeqNbr: selectedDepSeqNbrs[currentIndex]?.depSeqNbr,
          screenNumber: screenInfo.ADD[1],
        };
    const url = isAddMode(currentMode)
      ? "api/depDedSchDtlPatPaySchd/initialFormData/" + screenInfo.ADD[1]
      : "api/depDedSchDtlPatPaySchd/" +
        encodeURIComponent(scheduleName) +
        "/" +
        encodeURIComponent(stepNumber);

    try {
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        null,
        params
      );
      setInitialFormData(responseData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (isAddMode(currentMode) || (!lookupMode && selectedDepSeqNbrs.length)) {
      fetchInitialData();
    } else {
      setInitialFormData(baseFormData);
    }
  }, [mode, currentIndex, lookupMode]);

  useEffect(() => {
    if (
      Object.keys(baseFormData).length &&
      JSON.stringify(baseFormData) !== JSON.stringify(initialFormData)
    ) {
      setInitialFormData(baseFormData);
    }
  }, [baseFormData]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          viewLookupDetails={viewLookupDetails}
          lookupData={lookupData}
        />
      </div>
    </div>
  );
};

export default DeductiblePatientPayScheduleForm;